import axios from "axios";
import { Auth } from "aws-amplify";

const BASE_API_URLS = {
  development: "https://fcba17gw9k.execute-api.us-east-1.amazonaws.com",
  staging: "https://oo04cuccc6.execute-api.us-east-1.amazonaws.com",
  production: "https://byyhh7s57b.execute-api.us-east-1.amazonaws.com",
};

const getEnvironment = () => {
  if (import.meta.env.VITE_LOCAL_DEV === "true") {
    return "development";
  }
  if (import.meta.env.VITE_IS_STAGING === "true") {
    return "staging";
  }
  return "production";
};

const BASE_API_URL =
  import.meta.env.VITE_LOCAL_DEV === "true"
    ? "http://127.0.0.1:8000"
    : BASE_API_URLS[getEnvironment()];

const client = axios.create({
  baseURL: BASE_API_URL,
});

client.interceptors.request.use(async (config) => {
  const session = await Auth.currentSession();
  const jwtToken = session.accessToken.jwtToken;

  return {
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${jwtToken}`,
    },
  };
});

export default client;
